<template lang="pug">
  .module__main
    .module__title Список обменок
    .module-content__container.table-scroll
      .exchange-group__container(v-for="exchangeGroup in groupedExchanges" :key="`exchange-group-${exchangeGroup.name}`")
        .exchange-group__title
          .title {{ exchangeGroup.name }}
          el-button(
            v-if="exchangeGroup.is_aggregator"
            type="primary"
            size="mini"
            @click="startExchangeAggregatorUserAdding(exchangeGroup.name)"
            ) Добавить
        .exchange-group-info__container
          .exchange-group-info__data(v-if="!exchangeGroup.is_aggregator && !exchangeGroup.is_node")
            .exchange-group-info__title Общий баланс:
            .exchange-group-data__val {{ exchangeGroup.total_balance }}
        .exchange-group__data
          .exchange-group-exchange__container(v-for="exchange in exchangeGroup.exchanges" :key="`exchange-group-${exchangeGroup.name}-exchange-${exchange.name}`")
            .exchange-group-data__title.exchange__title
              .title  {{ exchange.name }}
              .exchange-delete__btn
                el-button(
                  v-if="exchange.is_exchange_from_aggregator"
                  type="danger"
                  size="mini"
                  circle
                  icon="el-icon-delete"
                  @click="startDeleteExchangeAggregatorUser(exchange.name, exchange.group)"
                  )
            .exchange-group-data__block
              .exchange-group-data__info(v-if="!exchange.show_node_wallets")
                .exchange-group-data__title Баланс:
                .exchange-group-data__val {{ exchange.balance }}
              .exchange-group-data__info(v-if="exchange.wallet")
                .exchange-group-data__title Кошелек:
                .exchange-group-data__val
                  span.exchange-wallet {{ exchange.wallet }}
                  i.el-icon-copy-document.control__btn(@click="copyTextToClipboard(exchange.wallet)")
              .exchange-accounts__container(v-if="exchange.show_accounts")
                .exchange-accounts__title
                  span Аккаунты
                  i.el-icon-edit.control__btn(@click="startExchangeAccountsEditing(exchange)")
                .exchange-accounts__block
                  .exchange-account__val(v-for="account in exchange.handler_accounts" :key="`exchange-group-${exchangeGroup.name}-exchange-${exchange.name}-account-${account.handler}-${account.name}`")
                    span.exchange-account-handler {{ account.handler }}:
                    span.exchange-account-name {{ account.name }}
                    span.exchange-account-balance {{ account.balance }}
              .exchange-accounts__container(v-if="exchange.show_node_wallets")
                .exchange-accounts__title Кошельки
                .exchange-accounts__block
                  .exchange-account__val(v-for="wallet in exchange.node_wallets" :key="`exchange-group-${exchangeGroup.name}-exchange-${exchange.name}-wallet-${wallet.addresss}`")
                    .val
                      span {{ wallet.address }}
                      i.ml5.el-icon-copy-document.control__btn(@click="copyTextToClipboard(wallet.address)")
                    .val
                      span.title.mr5 {{ wallet.name }}
                      span {{ wallet.balance }}
                    .val(v-if="wallet.token")
                      span.title.mr5 {{ wallet.token }}
                      span {{ wallet.balanceToken }}
    el-dialog(
      :visible.sync="isExchangeAccountsEditing"
      :before-close="resetExchangeAccountsEditing"
      :title="`Добавление аккаунта к обменке ${editingExchangeAccounts.exchange.name}`"
      width="50%"
      )
      EditExchangeAccounts(
        v-if="isExchangeAccountsEditing"
        :exchange="editingExchangeAccounts.exchange"
        @resetExchangeAccountsEditing="resetExchangeAccountsEditing"
        )
    el-dialog(
      :visible.sync="isExchangeAggregatorUserAdding"
      :before-close="resetExchangeAggregatorUserAdding"
      :title="`Добавление обменки к группе ${addingExchangeAggregatorUserGroup}`"
      width="50%"
      )
      AddExchangeAggregatorUser(
        v-if="isExchangeAggregatorUserAdding"
        :group="addingExchangeAggregatorUserGroup"
        @resetAddExchangeAggregatorUser="resetExchangeAggregatorUserAdding"
        )
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { DELETE_EXCHANGE_AGGREGATOR_USER, LOAD_EXCHANGES_INFO } from "@/store/const/exchanges";
import instruments from "@/mixins/instruments";
import EditExchangeAccounts from "@/views/Exchanges/EditExchangeAccounts.vue";
import { LOAD_HANDLER_ACCOUNTS_LIST } from "@/store/const/handlers";
import AddExchangeAggregatorUser from "@/views/Exchanges/AddExchangeAggregatorUser.vue";

export default {
  name: 'Exchanges',
  components: { AddExchangeAggregatorUser, EditExchangeAccounts },
  mixins: [
    instruments,
  ],
  data() {
    return {
      intervalHandle: null,
      isExchangeAccountsEditing: false,
      editingExchangeAccounts: {
        exchange: {},
      },
      isExchangeAggregatorUserAdding: false,
      addingExchangeAggregatorUserGroup: '',
    }
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('exchanges', [
      'exchanges',
    ]),
    isLoading() {
      return this.loading(LOAD_EXCHANGES_INFO) === 'loading';
    },
    groupedExchanges() {
      const result = {};
      const exchanges = ([...this.exchanges]).sort((a, b) => a.priority - b.priority);
      for (const exchange of exchanges) {
        if (!result[exchange.group]) {
          result[exchange.group] = { name: exchange.group, total_balance: 0, exchanges: [], accounts: [] };
        }
        result[exchange.group].total_balance = this.floatPlus(result[exchange.group].total_balance, exchange.balance);
        result[exchange.group].exchanges.push(exchange);
        result[exchange.group].accounts = exchange.accounts;
        if (exchange.is_exchange_from_aggregator) {
          result[exchange.group].is_aggregator = true;
        }
        if (exchange.is_node) {
          result[exchange.group].is_node = true;
        }
      }
      for (const exchange of exchanges) {
        result[exchange.group].exchanges = result[exchange.group].exchanges.sort((a, b) => a.priority - b.priority);
      }

      return result;
    }
  },
  async mounted() {
    await this.loadExchangesInfo();
    this.startInterval();
    await this.loadHandlersAccountsList();
  },
  beforeDestroy() {
    clearInterval(this.intervalHandle);
  },
  methods: {
    ...mapActions('exchanges', {
      loadExchangesInfo: LOAD_EXCHANGES_INFO,
      deleteExchangeAggregatorUser: DELETE_EXCHANGE_AGGREGATOR_USER,
    }),
    ...mapActions('handlers', {
      loadHandlersAccountsList: LOAD_HANDLER_ACCOUNTS_LIST,
    }),
    startInterval() {
      this.intervalHandle = setInterval(() => this.loadExchangesInfo(), 10000);
    },
    startExchangeAccountsEditing(exchange) {
      this.editingExchangeAccounts.exchange = exchange;
      this.isExchangeAccountsEditing = true;
    },
    resetExchangeAccountsEditing() {
      this.isExchangeAccountsEditing = false;
      this.editingExchangeAccounts.exchange = {};
    },
    startExchangeAggregatorUserAdding(group) {
      this.addingExchangeAggregatorUserGroup = group;
      this.isExchangeAggregatorUserAdding = true;
    },
    resetExchangeAggregatorUserAdding() {
      this.isExchangeAggregatorUserAdding = false;
      this.addingExchangeAggregatorUserGroup = '';
    },
    async startDeleteExchangeAggregatorUser(name, group) {
      this.$confirm(`Вы действительно хотите удалить пользователя ${name} из ${group}?`, 'Подтверждение').then(async () => {
        const request = await this.deleteExchangeAggregatorUser({
          group,
          name,
        });
        if (request.success) {
          this.$message.success('Удаление успешно');
        } else {
          this.$message.error(`Ошибка в удалении: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Удаление отменено');
      });
    },
  }
};
</script>
<style>
.exchange-group__container {
    padding: 8px;
    border: 1px solid #afafaf;
    background-color: #efefef;
    margin-bottom: 5px;
}

.exchange-group__title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: bold;
}

.exchange-group__title button {
    margin-left: 10px;
}

.exchange-group__data {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
}

.exchange-group-exchange__container {
    padding: 8px;
    border: 1px solid #afafaf;
    margin: 2px;
    background-color: #f7f7f7;
    border-radius: 4px;
}

.exchange-group-data__info {
    display: flex;
}

.exchange-group-data__title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    margin-right: 5px;
    margin-bottom: 5px;
}

.exchange-delete__btn {
    margin-left: 5px;
}

.exchange-group-info__data {
    display: flex;
    padding: 8px;
    border: 1px solid #afafaf;
    background-color: #f7f7f7;
    border-radius: 4px;
    width: fit-content;
}

.exchange-group-info__title {
    font-weight: bold;
    margin-right: 5px;
}

.exchange-wallet {
    margin-right: 5px;
    font-family: monospace;
    font-size: 16px;
}

.control__btn {
    cursor: pointer;
}

.control__btn:hover {
    color: #6b6969;
}

.exchange__title {
    text-shadow: 1px 1px #af9e9ebf;
    color: #333a95;
}

.table-scroll {
    overflow-y: scroll;
}

.exchange-accounts__container {
    padding: 4px;
    border: 1px solid #e1e1e1;
    font-size: 14px;
}

.exchange-account__val {
    border-bottom: 1px solid #c5c3c3;
    padding-bottom: 2px;
}

.exchange-account__val:hover {
    color: #4b4b4b;
    box-shadow: 1px 1px #cfcfcf;
}

.exchange-account__val:hover .exchange-account-balance {
    font-weight: bold;
}

.exchange-accounts__title {
    text-align: center;
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 5px;
}

.exchange-account-name {
    margin-right: 5px;
}

.exchange-account-handler {
    margin-right: 5px;
    text-transform: uppercase;
}
</style>
